<template>
  <div>
    <Transition name="fade">
      <div
        v-if="showBanner"
        class="text-slate-800 px-6 py-2 min-w-full text-xs font-medium h-min flex justify-between items-center consumption-banner"
        :class="
          userStore.getPlanCurrentLimit >= 100 ? 'bg-red-400' : 'bg-yellow-400'
        "
      >
        <div v-if="userStore.getPlanCurrentLimit >= 100">
          {{ $t('consumption_banner.limit_reached_title') }}
        </div>
        <div v-else>{{ $t('consumption_banner.reaching_limit_title') }}</div>
        <div>
          <q-btn
            @click="handleGetHelpNow"
            outline
            :label="$t('consumption_banner.get_help_now')"
            class="rounded px-4 py-1 text-extraSmall font-semibold h-6"
          />

          <q-icon
            name="close"
            class="cursor-pointer ml-4 close-consumption-banner"
            size="24px"
            @click="showBanner = false"
          />
        </div>
      </div>
    </Transition>
  </div>
</template>
<script setup lang="ts">
import { useUserStore } from 'src/core/stores/user';
import { ref } from 'vue';

const userStore = useUserStore();
const showBanner = ref(userStore.getPlanCurrentLimit >= 80);

function handleGetHelpNow() {
  window.open('mailto:support@meridia.land', '_blank');
}

defineExpose({ showBanner });
</script>
<style lang="scss" scoped></style>
